// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__33zEW","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__-5fQs"};